import React from "react";
import { SideNavElement } from "./SideNavElement";
import { observer } from "mobx-react";
export const SideNavLogin = observer((props) => {
    const doLogin = () => {
        props.appModel.login();
    };
    const doLogout = () => {
        props.appModel.logout();
    };
    if (props.authInfo.isAuthenticated == true) {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "block-openid-connect-zeb", id: "block-zeblogin" },
                React.createElement(SideNavElement, { title: props.appModel.i18n("logintoggle.logout.alt"), onClick: doLogout, imageSrc: props.appModel.pathToStatic + "images/icon_lock_open.svg", appModel: props.appModel }))));
    }
    else {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "block-openid-connect-zeb", id: "block-zeblogin" },
                React.createElement(SideNavElement, { title: props.appModel.i18n("logintoggle.login.alt"), onClick: doLogin, imageSrc: props.appModel.pathToStatic + "images/icon_lock.svg", appModel: props.appModel }))));
    }
});
export default SideNavLogin;
